<template>
  <div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-table
        ref="table"
        title="유해위험기계기구 목록"
        :columns="grid.columns"
        :merge="grid.merge"
        :gridHeightAuto="true"
        :data="focus.hazardFocusInspEquipModelList"
        :columnSetting="false"
        :filtering="false"
        :usePaging="false"
        selection="multiple"
        :editable="editable && !disabled"
        rowKey="hhmHazardousMachineryId"
        @linkClick="linkClick"
      >
        
        <template slot="table-button">
          <q-btn-group outline>
            <c-btn v-if="editable && !disabled" :showLoading="false" label="추가" icon="add" @btnClicked="addEquip" />
            <c-btn v-if="editable && !disabled && focus.hazardFocusInspEquipModelList.length > 0" :showLoading="false"  label="제외" icon="remove" @btnClicked="removeEquip" />
          </q-btn-group>
        </template>
      </c-table>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
export default {
  name: 'hazard-focus-inspection-equip',
  props: {
    focus: {
      type: Object,
      default: () => ({
        plantCd: '',
        focusInspectionId: '',
        machineryTypeCd: '',

        hazardFocusInspItemModelList: [],
        hazardFocusInspItemCommonModelList: [],

        hazardFocusInspEquipModelList: [],
        deleteHazardFocusInspEquipModelList: [],
      }),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editable: true,
      detailUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        param: {},
        closeCallback: null,
      },
      grid: {
        columns: [
          {
            name: "emplacementPlace",
            field: "emplacementPlace",
            label: "설비위치",
            style: 'width:150px', 
            align: "left",
            sortable: true,
          },
          {
            name: "machineryName",
            field: "machineryName",
            label: "형식(규격)",
            style: 'width:150px', 
            align: "left",
            sortable: true,
          },
          {
            name: "machineryClassification",
            field: "machineryClassification",
            label: "설비종류",
            style: 'width:100px', 
            align: "center",
            sortable: true,
          },
        ],
        height: "650px",
        data: [],
      },
      saveCall: {
        saveCallData: '',
      },
      getUrl: '',
      colorItems:[],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
    },
    /* eslint-disable no-unused-vars */ 
    linkClick(row, col, index) {
      this.popupOptions.title = "유해위험기계기구 상세"; // 유해위험기계기구 상세
      this.popupOptions.param = {
        hhmHazardousMachineryId: row ? row.hhmHazardousMachineryId : '',
      };
      this.popupOptions.target = () =>
        import(`${"./hazardEquipmentClassDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.height = '300px';
      this.popupOptions.isFull = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup(type) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
    addEquip() {
      if (!this.focus.plantCd) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '사업장을 선택하세요.',
          type: 'warning', // success / info / warning / error
        });
      }
      this.popupOptions.title = "유해위험기계기구 검색"; // 유해위험기계기구 검색
      this.popupOptions.param = {
        type: "multiple",
        plantCd: this.focus.plantCd, 
      };
      this.popupOptions.target = () =>
        import(`${"./hazardEquipmentClassPop.vue"}`);
      this.popupOptions.isFull = true;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeMachineryPopup;

    },
    closeMachineryPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.$_.forEach(data, _item => {
          let index = this.$_.findIndex(this.focus.hazardFocusInspEquipModelList, {
            hhmHazardousMachineryId: _item.hhmHazardousMachineryId,
          });
          if (index === -1) {
            this.focus.hazardFocusInspEquipModelList.splice(0, 0, {
              focusInspectionId: this.focus.focusInspectionId,
              hhmHazardousMachineryId: _item.hhmHazardousMachineryId,
              emplacementPlace: _item.emplacementPlace,
              machineryClassification: _item.machineryClassification,
              machineryName: _item.machineryName,
              chgUserId: this.$store.getters.user.userId,
              regUserId: this.$store.getters.user.userId,
              editFlag: 'C'
            })
          }
        })
      }
    },
    removeEquip() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$_.forEach(selectData, item => {
          if (!this.focus.deleteHazardFocusInspEquipModelList) {
            this.focus.deleteHazardFocusInspEquipModelList = []
          }

          this.$_.forEach(this.focus.hazardFocusInspItemCommonModelList, _item => {
            if (!_item.hazardFocusInspItemEquipModelList) return;
            if (this.$_.findIndex(_item.hazardFocusInspItemEquipModelList, {hhmHazardousMachineryId:item.hhmHazardousMachineryId}) > -1) {
              _item.hazardFocusInspItemEquipModelList = this.$_.reject(_item.hazardFocusInspItemEquipModelList, {hhmHazardousMachineryId:item.hhmHazardousMachineryId})
            }
          })
          this.$_.forEach(this.focus.hazardFocusInspItemModelList, _item => {
            if (!_item.hazardFocusInspItemEquipModelList) return;
            if (this.$_.findIndex(_item.hazardFocusInspItemEquipModelList, {hhmHazardousMachineryId:item.hhmHazardousMachineryId}) > -1) {
              _item.hazardFocusInspItemEquipModelList = this.$_.reject(_item.hazardFocusInspItemEquipModelList, {hhmHazardousMachineryId:item.hhmHazardousMachineryId})
            }
          })
          if (this.$_.findIndex(this.focus.deleteHazardFocusInspEquipModelList, { hhmHazardousMachineryId: item.hhmHazardousMachineryId }) === -1
            && item.editFlag !== 'C') {
              this.focus.deleteHazardFocusInspEquipModelList.push(item)
          }
          this.focus.hazardFocusInspEquipModelList = this.$_.reject(this.focus.hazardFocusInspEquipModelList, item)
        })
      }
    },
  }
};
</script>
